<ik-card-selectable (click)="switchPermission('limited')"
                    [class.partnerChoice]="!wantFullAccess"
                    [isSelected]="selectedPermission === 'limited'">
  <ng-container badge>
    {{!wantFullAccess ? ('Permission demandee' | transloco) : ''}}
  </ng-container>
  <ng-container header>
    {{'Acces limite' | transloco}}
  </ng-container>
  <ng-container main>
    <app-ik-card-selectable-icon-item [cards]="limitedAccess">
    </app-ik-card-selectable-icon-item>
  </ng-container>
  <ng-container footer>
    <button (click)="switchPermission('limited')"
            *ngIf="wantFullAccess && selectedPermission !== 'limited'"
            color="accent"
            mat-flat-button>
      {{'Passer en acces limite' | transloco}}
    </button>
    <button (click)="switchPermission('limited')"
            *ngIf="!wantFullAccess && selectedPermission !== 'limited'"
            color="accent"
            mat-flat-button>
      {{'Rester en acces limite' | transloco}}
    </button>
    <button *ngIf="selectedPermission === 'limited'"
            [attr.aria-label]="'selected' | transloco"
            color="primary"
            mat-flat-button>
      <span class="icon icon-check"></span>
    </button>
  </ng-container>
</ik-card-selectable>
<ik-card-selectable (click)="switchPermission('full')"
                    [class.notPossible]="selectedAccount.in_partnership_limited"
                    [class.partnerChoice]="wantFullAccess"
                    [isSelected]="selectedPermission === 'full'"
                    [matTooltipPosition]="'below'"
                    matTooltip="{{
                             selectedAccount.in_partnership_limited ? ('Vous avez deja un ou plusieurs partenaire en acces limite sur cette organisation et ne pouvez pas ajouter un partenaire en acces complet.' | transloco) : null}}"
                    matTooltipClass="custom-tooltip">
  <ng-container badge>
    {{wantFullAccess ? ('Permission demandee' | transloco) : ''}}
  </ng-container>
  <ng-container header>
    {{'Acces complet' | transloco}}
    <!--        <span class="admin">{{'(Admin.)' | transloco}}</span>-->
  </ng-container>
  <ng-container main>
    <app-ik-card-selectable-icon-item [cards]="fullAccess">
    </app-ik-card-selectable-icon-item>
    <div *ngIf="!selectedAccount.in_partnership_limited"
         class="infos-payment"> *
      {{ 'Vous pourrez definir a l\'etape suivante, si le partenaire utilisera ses moyens de paiement ou les votres.' | transloco}}
    </div>
  </ng-container>
  <ng-container *ngIf="!selectedAccount.in_partnership_limited"
                footer>
    <button (click)="switchPermission('full')"
            *ngIf="!wantFullAccess && selectedPermission !== 'full'"
            color="accent"
            mat-flat-button>
      {{'Passer en acces complet' | transloco}}
    </button>
    <button (click)="switchPermission('full')"
            *ngIf="wantFullAccess && selectedPermission !== 'full'"
            color="accent"
            mat-flat-button>
      {{'Rester en acces complet' | transloco}}
    </button>
    <button *ngIf="selectedPermission === 'full'"
            [attr.aria-label]="'selected' | transloco"
            color="primary"
            mat-flat-button>
      <span class="icon icon-check"></span>
    </button>
  </ng-container>
</ik-card-selectable>
